// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--GGfk7";
export var contentWrapper = "style-module--contentWrapper--dL2wa";
export var mobileImage = "style-module--mobileImage--fo1ve";
export var root = "style-module--root--+KC0h";
export var splashWrapper = "style-module--splashWrapper--Kqh8V";